// E-Fatura Gönder penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.eInvoiceSend';

export const eInvoiceSendGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'E-fatura nasıl gönderilir?'),
  intro: t(`${G}.intro`, 'Kayıtlı bir satış faturasını üç adımda GİB\'e resmi e-fatura / e-arşiv belgesi olarak gönderirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'E-Fatura Gönder'),
    tabs: t(`${G}.regions.tabs`, 'Adımlar'),
    body: t(`${G}.regions.body`, 'Adım içeriği'),
    footer: t(`${G}.regions.footer`, 'İleri / Gönder'),
  },
  navItems: [
    t(`${G}.nav.check`, 'Bilgi Kontrolü'),
    t(`${G}.nav.preview`, 'Önizleme'),
    t(`${G}.nav.send`, 'Gönderim'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Faturayı aktif e-fatura entegrasyonunuz (Finansbank, EDM veya PavoPay) üzerinden GİB\'e gönderir. Gönderilen e-fatura resmi belgedir; bu pencereden geri alınamaz, bu yüzden bilgileri dikkatle kontrol edin.'),
      tips: [
        t(`${G}.s1.tip1`, 'Üstteki adım çubuğu nerede olduğunuzu gösterir: Bilgi Kontrolü → Önizleme → Gönderim.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Entegrasyon, seri ve tasarım şablonu'),
      text: t(`${G}.s2.text`, 'Yeşil kutuda faturanın şubesine göre bulunan aktif entegrasyon görünür. "Aktif entegrasyon bulunamadı" yazıyorsa önce E-Fatura ekranındaki Entegrasyon Ayarları\'nı yapın; o zamana kadar İleri kapalıdır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Fatura Serisi (EDM): resmi fatura numarası EDM\'deki son sıranın bir fazlasından üretilir. "Otomatik" entegrasyon ayarındaki seriyi kullanır.'),
        t(`${G}.s2.tip2`, 'Tasarım Şablonu (EDM / PavoPay): "Otomatik" varsayılan işaretli şablonu kullanır; şablon yoksa entegratörün tasarımı kullanılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Alıcı (cari) bilgilerini kontrol edin'),
      text: t(`${G}.s3.text`, 'Cari Bilgileri tablosunda ünvan, vergi numarası, vergi dairesi ve adres görünür. Vergi Numarası veya Adres eksikse İleri kapalı kalır; faturayı düzenleyip eksikleri tamamlayın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Vergi Dairesi eksikliği gönderime engel değildir; e-arşiv / bireysel alıcıda zorunlu değildir, kurumsal alıcıda doldurulması önerilir.'),
        t(`${G}.s3.tip2`, 'Profil Türü (Temel / Ticari) ve Fatura Tip Kodu faturadan gelir, burada yalnız gösterilir.'),
        t(`${G}.s3.tip3`, 'İade faturasında iade edilen orijinal faturanın seçilmesi zorunludur; fatura oluşturulurken belirlendiyse burada değiştirilemez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Önizleyin'),
      text: t(`${G}.s4.text`, 'Önizleme adımında fatura no, tarih, satıcı ve alıcı, kalemler ve toplamlar (Ara Toplam, İndirim, KDV, Genel Toplam) gösterilir. Belge tipi (E-Fatura / E-Arşiv) alıcının mükellefiyetine göre kendiliğinden belirlenir.'),
      tips: [
        t(`${G}.s4.tip1`, '"Fatura Görseli (tasarım şablonuyla)" bölümünü açınca faturanın seçilen şablonla nasıl görüneceğini görürsünüz (EDM / PavoPay).'),
        t(`${G}.s4.tip2`, 'Bir şeyi düzeltmek için "Geri" ile önceki adıma dönün.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Gönderin ve sonucu okuyun'),
      text: t(`${G}.s5.text`, 'Gönderim adımında "Gönder"e basın. Başarılı olursa resmi fatura numarası ve belge bilgileri gösterilir, fatura "Gönderildi" olarak işaretlenir. "Kapat ve Listeyi Yenile" ile pencereyi kapatın. Başlıktaki (i) bu rehberi yeniden açar.'),
      tips: [
        t(`${G}.s5.tip1`, 'Fatura GİB\'de zaten varsa "Fatura Zaten Gönderilmiş" yazar ve tekrar gönderilmez.'),
        t(`${G}.s5.tip2`, 'Hata olursa kırmızı kutuda nedeni yazar; sorunu giderip yeniden "Gönder"e basabilirsiniz.'),
      ],
    },
  ],
});
